import type { CaptureContext } from '@sentry/core';
import * as Sentry from '@sentry/react';

import IUser from 'types/IUser';

import { trackMixpanelEvent } from './mixpanel-init';

export const addLogsToSentry = (
  userObj: Partial<IUser> | null,
  logEntry: string | Error | object,
  captureContext?: CaptureContext
) => {
  Sentry.withScope(scope => {
    if (userObj) {
      scope.setUser(userObj);
    }
    if (typeof logEntry === 'object') {
      if (logEntry instanceof Error) {
        Sentry.captureException(logEntry, captureContext);
        return;
      }
      Sentry.captureException(new Error(JSON.stringify(logEntry)), captureContext);
    } else {
      Sentry.captureMessage(logEntry, captureContext);
    }
  });
};

export const addLogsInSentryAndMixpanel = (
  userObj: Partial<IUser>,
  title: string,
  captureContext?: CaptureContext
) => {
  trackMixpanelEvent(title, captureContext?.extra ?? {});

  addLogsToSentry(userObj, title, captureContext);
};
